import * as AscertainSagas from './ascertain';
import * as CQSagas from './cq';
import * as ManualSagas from './manual';
import * as CatalogSagas from './catalog';
import * as CustomizerSagas from './customizer';
import * as ProductSagas from './products';
import * as ClientSagas from './client';
import * as StepsSagas from './steps';
import * as SESagas from './se';
import * as NextStepsSagas from './nextSteps';
import * as MobileInsuranceSagas from './mobileInsurance';
import * as OBDSagas from './obd';
import * as PaymentSagas from './payment';
import * as BuyBackSagas from './buyBack';
import * as R2R2Sagas from './r2r';
import * as DisagregateProductSaga from './disagregate';
import * as FTTRSagas from './fttr';
import * as RegisterSagas from './register';
import * as RiskSagas from './risk';
import * as CampaignSagas from './campaign';
import * as DuoSagas from './duo';
import * as GenesysSagas from './genesys';

export const minderSagas = {
  ...AscertainSagas,
  ...CQSagas,
  ...ManualSagas,
  ...ClientSagas,
  ...CustomizerSagas,
  ...StepsSagas,
  ...SESagas,
  ...CatalogSagas,
  ...ProductSagas,
  ...NextStepsSagas,
  ...MobileInsuranceSagas,
  ...OBDSagas,
  ...PaymentSagas,
  ...BuyBackSagas,
  ...R2R2Sagas,
  ...DisagregateProductSaga,
  ...FTTRSagas,
  ...RegisterSagas,
  ...RiskSagas,
  ...CampaignSagas,
  ...DuoSagas,
  ...GenesysSagas,
};
